<template>
  <div
    v-if="options.length > 0"
    id="device-brand"
    class="pretty-select add-to-cart__casedevice__device composite-device-selector__brand"
  >
    <lazy-hydrate v-slot="{ hydrated }" when-visible>
      <select
        v-if="hydrated"
        :id="inputId"
        v-model="inputValue"
        :name="inputName"
        class="pretty-select__select"
      >
        <option value="" disabled style="display: none">
          {{ $t('product_form.select_brand') }}
        </option>
        <option
          v-for="brand in options"
          :key="brand"
          :value="getOptionValue(brand)"
        >
          {{ getOptionText(brand) }}
        </option>
      </select>
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import customInput from '~/mixins/custom-input'
import BaseSelect from '~/components/product/form/BaseSelect'

export default {
  name: 'DeviceBrandSelector',
  components: { LazyHydrate },
  extends: BaseSelect,
  mixins: [customInput],
  props: {
    /** If true, select first option automatically */
    autoSelect: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    inputName() {
      return this.customInputName || 'device_brand'
    },
    inputId() {
      return this.customInputId || 'device_brand'
    },
  },
}
</script>
